/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { SectionShell } from '../../atoms/SectionShell/SectionShell';
import type { ComparisonSectionProps } from './ComparisonSection.types';

export const ComparisonSection = ({ topic, className }: ComparisonSectionProps) => {
  const { t } = useInt();

  if (!topic.comparison) {
    return null;
  }

  const paragraphs = topic.comparison.split('\n\n').filter(Boolean);

  return (
    <SectionShell id="comparison" title={t('Distinctions that matter')} className={className}>
      {paragraphs.map((paragraph, i) => (
        <p key={i}>{paragraph}</p>
      ))}
    </SectionShell>
  );
};
